// Pure helpers for the redesigned Audit Trail modal (2026-10-13).

const round2 = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100;

/** Signed gap between what was paid and the invoice total(s) settled; null when exact. */
export function paymentVariance(paid: number, invoices: { total: number }[]): number | null {
  const subtotal = round2(invoices.reduce((s, i) => s + (i.total || 0), 0));
  const diff = round2(paid - subtotal);
  return Math.abs(diff) < 0.02 ? null : diff;
}

/** A journal entry balances when its Dr total equals its Cr total (±0.01). */
export function entryBalanced(lines: { debit?: number | null; credit?: number | null }[]): boolean {
  const dr = round2(lines.reduce((s, l) => s + (l.debit || 0), 0));
  const cr = round2(lines.reduce((s, l) => s + (l.credit || 0), 0));
  return Math.abs(dr - cr) < 0.01;
}

/**
 * Friendly one-line label for an audit_log action. `changes` is the raw JSON
 * string from audit_log; for confirm_match it may carry a reviewed variance
 * reason which is surfaced in the label.
 */
export function auditEventLabel(action: string, changes?: string | null): string {
  let parsed: any = null;
  if (changes) { try { parsed = JSON.parse(changes); } catch { /* ignore */ } }

  switch (action) {
    case 'confirm_match':
      return parsed?.review_reason
        ? `Match confirmed — reviewed variance ${parsed.variance_amount}: ${parsed.review_reason}`
        : 'Match confirmed by user';
    case 'unlink_match':
    case 'unlink': return 'Match unlinked';
    case 'import': return 'Imported from uploaded document';
    case 'create': return 'Created';
    case 'update': return 'Edited';
    case 'soft_delete': return 'Moved to recycle bin';
    case 'restore': return 'Restored from recycle bin';
    case 'purge': return 'Permanently purged';
    case 'review_statement': return 'Reviewed statement vs ledger';
    case 'confirm': return 'Statement confirmed';
    default: return action;
  }
}
